import Inversemsline from '@fusioncharts/powercharts/src/chart/inversemsline';
export default Inversemsline;
